import * as R from 'ramda';

export default function RiskAdminController(
  $q,
  $scope,
  loaderService,
  editRiskDialog,
  ssDialogService,
  userService,
  riskDataService,
  riskSharedModelService,
  riskSettingsDialog,
) {
  const vm = this;
  vm.appIsLoaded = false;
  vm.groupId = 53;
  vm.controls = [];

  vm.handleShowAddRiskClick = _handleShowAddRiskClick;
  vm.handleShowSettings = _handleShowSettings;
  _activate();

  function _activate() {
    const dfdActivate = $q.defer();

    _initEventListeners();
    _initPermissions();

    const getRisks = _refreshRisks();
    $q.all([
      getRisks,
    ]).then(() => {
      vm.appIsLoaded = true;
      dfdActivate.resolve();
    });

    return dfdActivate.promise;
  }

  function _initEventListeners() {
    $scope.$on('refreshRisks', _refreshRisks);
    $scope.$on('refreshRiskTypes', _refreshRisks);
    // $scope.$on('refreshRiskControls', _refreshRisks);
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('policyRiskAssessment')
      .then((permissions) => {
        loaderService.showViewLoader = false;
        vm.permissions = permissions;
      });
  }

  function _handleShowAddRiskClick($event) {
    loaderService.showViewLoader = true;
    const risk = { customerRiskId: 0 };
    $q.all([
      // riskDataService.getRiskTypes(),
      // assetDataService.getAssets(),
      riskDataService.getRiskById(risk.customerRiskId),
      riskDataService.getRiskTypeDefaults()
    ]).then((response) => {
      loaderService.showViewLoader = false;
      risk.riskOnsetId = response[1].data.riskOnset.riskOnsetId;
      risk.riskForewarningId = response[1].data.riskForewarning.riskForewarningId;
      risk.riskDurationId = response[1].data.riskDuration.riskDurationId;
      risk.riskDataConfidentialityId = response[1].data.riskDataConfidentiality.riskDataConfidentialityId;
      risk.riskDataIntegrityId = response[1].data.riskDataIntegrity.riskDataIntegrityId;
      risk.riskDataAvailabilityId = response[1].data.riskDataAvailability.riskDataAvailabilityId;
      risk.riskDirectionId = response[1].data.riskDirection.riskDirectionId;
      risk.riskTrendingId = response[1].data.riskTrending.riskTrendingId;
      risk.riskAssessmentFrequencyId = response[1].data.riskAssessmentFrequency.riskAssessmentFrequencyId;
      risk.riskProbabilityId = response[1].data.riskProbability.riskProbabilityId;
      risk.riskClassificationId = response[1].data.riskClassification.riskClassificationId;
      ssDialogService.dialogs.riskAdmin.editRiskDialog = ssDialogService.alert(
        editRiskDialog.getOptions($event, {
          risk,
          riskTypes: response[0].data.CustomerRiskTypes,
          assets: response[0].data.CustomerAssetData,
          riskOnsets: riskSharedModelService.RiskOnsets,
          riskForewarnings: riskSharedModelService.RiskForewarnings,
          riskDurations: riskSharedModelService.RiskDurations,
          riskDataConfidentialities: riskSharedModelService.RiskDataConfidentialities,
          riskDataIntegrities: riskSharedModelService.RiskDataIntegrities,
          riskDataAvailabilities: riskSharedModelService.RiskDataAvailabilities,
          riskDirections: riskSharedModelService.RiskDirections,
          riskTrendings: riskSharedModelService.RiskTrendings,
          riskAssessmentFrequencies: riskSharedModelService.RiskAssessmentFrequencies,
          riskProbabilities: riskSharedModelService.RiskProbabilities,
          riskClassifications: riskSharedModelService.RiskClassifications,
          isRiskMain: true,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.riskAdmin.editRiskDialog);
    });
  }

  function _refreshRisks() {
    const dfdItem = $q.defer();

    riskDataService.init().then((response) => {
      vm.riskTypeList = response.data.RiskType.result;
      _initPage(response);
      transformRiskTypeList();
      dfdItem.resolve();
    });

    return dfdItem.promise;
  }

  function _initPage(getRiskInitResponse) {
    // return riskDataService.initRiskAdmin().then((getRiskInitResponse) => {
    if (getRiskInitResponse.data.RiskOnsets) {
      vm.riskOnsets = getRiskInitResponse.data.RiskOnsets.result;
      riskSharedModelService.RiskOnsets = vm.riskOnsets;
    }

    if (getRiskInitResponse.data.RiskForewarnings) {
      vm.riskForewarnings = getRiskInitResponse.data.RiskForewarnings.result;
      riskSharedModelService.RiskForewarnings = vm.riskForewarnings;
    }

    if (getRiskInitResponse.data.RiskDurations) {
      vm.riskDurations = getRiskInitResponse.data.RiskDurations.result;
      riskSharedModelService.RiskDurations = vm.riskDurations;
    }

    if (getRiskInitResponse.data.RiskDataConfidentialities) {
      vm.riskDataConfidentialities = getRiskInitResponse.data.RiskDataConfidentialities.result;
      riskSharedModelService.RiskDataConfidentialities = vm.riskDataConfidentialities;
    }

    if (getRiskInitResponse.data.RiskDataIntegrities) {
      vm.riskDataIntegrities = getRiskInitResponse.data.RiskDataIntegrities.result;
      riskSharedModelService.RiskDataIntegrities = vm.riskDataIntegrities;
    }

    if (getRiskInitResponse.data.RiskDataAvailabilities) {
      vm.riskDataAvailabilities = getRiskInitResponse.data.RiskDataAvailabilities.result;
      riskSharedModelService.RiskDataAvailabilities = vm.riskDataAvailabilities;
    }

    if (getRiskInitResponse.data.RiskDirections) {
      vm.riskDirections = getRiskInitResponse.data.RiskDirections.result;
      riskSharedModelService.RiskDirections = vm.riskDirections;
    }

    if (getRiskInitResponse.data.RiskTrendings) {
      vm.riskTrendings = getRiskInitResponse.data.RiskTrendings.result;
      riskSharedModelService.RiskTrendings = vm.riskTrendings;
    }

    if (getRiskInitResponse.data.RiskAssessmentFrequencies) {
      vm.riskAssessmentFrequencies = getRiskInitResponse.data.RiskAssessmentFrequencies.result;
      riskSharedModelService.RiskAssessmentFrequencies = vm.riskAssessmentFrequencies;
    }

    if (getRiskInitResponse.data.RiskProbabilities) {
      vm.riskProbabilities = getRiskInitResponse.data.RiskProbabilities.result;
      riskSharedModelService.RiskProbabilities = vm.riskProbabilities;
    }

    if (getRiskInitResponse.data.RiskClassifications) {
      vm.riskClassifications = getRiskInitResponse.data.RiskClassifications.result;
      riskSharedModelService.RiskClassifications = vm.riskClassifications;
    }

    if (getRiskInitResponse.data.CustomerRiskInherentSeverityLevels) {
      vm.customerRiskInherentSeverityLevels = getRiskInitResponse.data.CustomerRiskInherentSeverityLevels.result;
      riskSharedModelService.CustomerRiskInherentSeverityLevels = vm.customerRiskInherentSeverityLevels;
    }
    // });
  }

  function _handleShowSettings($event) {
    loaderService.showViewLoader = true;
    const promises = [
      riskDataService.getRiskTypes(),
    ];

    $q.all(promises)
      .then((response) => {
        ssDialogService.dialogs.riskAdmin.settingRiskDialog = ssDialogService.alert(
          riskSettingsDialog.getOptions($event, {
            riskTypeList: response[0].data.result
          })
        );
        ssDialogService.show(ssDialogService.dialogs.riskAdmin.settingRiskDialog);
        loaderService.showViewLoader = false;
      });
  }

  function transformRiskTypeList() {
    R.forEach(
      (type) => {
        riskSharedModelService.transformRiskTop(type);
      },
      vm.riskTypeList
    );
  }
}

RiskAdminController.$inject = [
  '$q',
  '$scope',
  'loaderService',
  'editRiskDialog',
  'ssDialogService',
  'userService',
  'riskDataService',
  'riskSharedModelService',
  'riskSettingsDialog',
];
